/**
 * Flag Helpers
 * Provides country flag icon lookups for satellite sources
 */

import notFound from '@/assets/images/flag-not-found.png';
import flags from './flags.json';

interface Flag {
  flag_name: string;
  icon_png: string;
}

/**
 * Creates an indexed map of flags for O(1) lookup
 * This is computed once and reused across all components
 */
const createFlagMap = (flagsArray: Flag[]): Record<string, string> => {
  return flagsArray.reduce(
    (acc, flag) => {
      acc[flag.flag_name] = flag.icon_png;
      return acc;
    },
    {} as Record<string, string>,
  );
};

/**
 * Pre-computed flag map for fast lookups
 * This runs only once when the module is imported
 */
export const FLAG_MAP = createFlagMap(flags as Flag[]);

/**
 * Gets flag icon for a given source name
 * O(1) complexity - instant lookup
 * @param source - The satellite source name
 * @returns The flag icon URL or notFound image
 */
export function getFlagIcon(source: string): string {
  return FLAG_MAP[source] || notFound;
}
